import api from '@/services/api'

export default {
    listSubjects(payload) {
        return api.get(`lists`, { params: payload })
            .then(response => response.data,
                error => error.response.data)
    }
}